export default __webpack_public_path__ + "static/media/img_affliate_bg.875695ff.webp";